export default __webpack_public_path__ + "static/media/imagePlaceHolder.34f484cd.svg";